import PropTypes from 'prop-types';
import React, { Component } from 'react';

class DefaultInstallerPayRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: (props.patchItem.default_installer_pay / 100).toFixed(2),
      dirty: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patchItem.default_installer_pay !== this.props.patchItem.default_installer_pay) {
      this.setState({
        value: (nextProps.patchItem.default_installer_pay / 100).toFixed(2),
        dirty: false,
      });
      this.props.onDirtyChange(nextProps.patchItem.id, null);
    }
  }

  handleChange = (e) => {
    const { value } = e.target;
    const cents = Math.round(parseFloat(value || 0) * 100);
    this.setState({ value, dirty: true });
    this.props.onDirtyChange(this.props.patchItem.id, cents);
  }

  handleSave = () => {
    const cents = Math.round(parseFloat(this.state.value || 0) * 100);
    this.props.onSave(this.props.patchItem.id, cents);
    this.setState({ dirty: false });
    this.props.onDirtyChange(this.props.patchItem.id, null);
  }

  render() {
    const { patchItem } = this.props;
    return (
      <tr>
        <td style={{ textAlign: 'center', padding: '8px' }}>{patchItem.item_number}</td>
        <td style={{ textAlign: 'center', padding: '8px' }}>{patchItem.price_patch_name}</td>
        <td style={{ textAlign: 'center', padding: '8px' }}>{patchItem.description}</td>
        <td style={{ textAlign: 'center', padding: '8px' }}>
          <input
            type="number"
            step="0.01"
            min="0"
            value={this.state.value}
            onChange={this.handleChange}
            style={{ width: '100px' }}
          />
          <button
            type="button"
            disabled={!this.state.dirty}
            onClick={this.handleSave}
            style={{ marginLeft: '8px' }}
          >
            Save
          </button>
        </td>
      </tr>
    );
  }
}

DefaultInstallerPayRow.propTypes = {
  patchItem: PropTypes.shape({
    id: PropTypes.number,
    item_number: PropTypes.string,
    description: PropTypes.string,
    default_installer_pay: PropTypes.number,
    price_patch_name: PropTypes.string,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  onDirtyChange: PropTypes.func.isRequired,
};

export default DefaultInstallerPayRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/defaultInstallerPay/DefaultInstallerPayRow.jsx